import { database } from './firebase'
import config  from '../config/config'
import styled from 'styled-components';
import DetectRTC from 'detectrtc';
import * as Sentry from '@sentry/browser';

export const version = () => {
  return '1.0.27'
}



export const localDebug = () => {  // for local network debugging
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(window.location.hostname)) {  
    return true
  }  
  return false
}  



export const netlifyDebug = () => { 
  var full = window.location.host
  var parts = full.split('.')
  var sub = parts[1]

  if (sub == "netlify") {  
    return true
  }  
  return false
}  


export const isWebinar = () => {

  var full = window.location.host
  var parts = full.split('.')
  var sub = parts[0]
  if (sub.match(/webinar/)) {  
    return true
  }  




  const params = new URLSearchParams(window.location.search);
  if (params.get('mode') == "webinar"){
    return true
  }

  

  let hostname 
  var regexp = new RegExp("^(.+[^.]\.)?ngrok\.io$");
  if( localDebug() || window.location.hostname === "192.168.89.118"|| window.location.hostname === "localhost" || window.location.hostname.match(regexp)){
    return config.WEBINAR_DEBUG
  }else{
    hostname = window.location.hostname
  }

  if(hostname === "video.workshop-live.com" || hostname === "video-dev.workshop-live.com" ){
    return true
  }else{
    return false
  }
}

export const isFVlite = () => {


  var full = window.location.host
  var parts = full.split('.')
  var sub = parts[0]
  if (sub.match(/fvlite/)) {  
    return true
  }  


  const params = new URLSearchParams(window.location.search);
  if (params.get('mode') == "fvlite"){
    return true
  }



  let hostname 
  var regexp = new RegExp("^(.+[^.]\.)?ngrok\.io$");
  if( localDebug() || window.location.hostname === "192.168.89.118"|| window.location.hostname === "localhost" || window.location.hostname.match(regexp)){
    return config.FVLITE_DEBUG
  }else{
    hostname = window.location.hostname
  }

  var full = window.location.host
  var parts = full.split('.')
  var sub = parts[1]

  if( sub === "lfv"){
    return true
  }else{
    return false
  }
}

export const checkMobile = () => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const Android = /android|Android/.test(navigator.userAgent)
  return iOS || Android
}


export const isSafari = () => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return iOS
}


export const checkPlatform = () => {  
  
  // let standalone = window.navigator.standalone,
  //   userAgent = window.navigator.userAgent.toLowerCase(),
  //   safari = /safari/.test( userAgent ),
  //   ios = /iphone|ipod|ipad/.test( userAgent );
  //   if( ios ) {
  //       if ( !standalone && safari ) {
  //           //browser
  //           alert("nakajima1")
  //       } else if ( standalone && !safari ) {
  //           //standalone
  //           alert("nakajima2")
  //       } else if ( !standalone && !safari ) {
  //           alert("nakajima3")
  //           //uiwebview
  //       };
  //   } else {
  //       //not iOS
  //   };

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  // if(iOS){
  //   if(!isWebinar()){
  //     window.location = `sessionsdd://open.sessions${window.location.pathname}`
  //     setTimeout(() => {
  //       window.location = "https://itunes.apple.com/jp/app/dd/id1435000009?mt=8"
  //     }, 2000)
  //   }else{
  //     window.location = `fvwebinar://${(window.location.pathname+window.location.search).substr(1)}`
  //     setTimeout(() => {
  //       window.location = "https://itunes.apple.com/jp/app/workshop-mobile/id1325343868?l=jp&mt=8"
  //     }, 2000)
  //   }
  //   return
  // }

  const Android = /android|Android/.test(navigator.userAgent)
  // if(Android){
  //   if(!isWebinar()){
      
  //     window.location = `sessionsdd://open.sessions${window.location.pathname}`
  //     setTimeout(() => {
  //       window.location = "https://play.google.com/store/apps/details?id=com.sessions_mobile"
  //     }, 2000)
  //   }else{
  //     window.location = `fvwebinar://${(window.location.pathname+window.location.search).substr(1)}`
  //     setTimeout(() => {
  //       window.location = "https://play.google.com/store/apps/details?id=com.fvwebinar"
  //     }, 2000)
  //   }
  //   return
  // }
  

  let update_flag = true
  if (  !detectmob() && !(/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))){
    if(checkJapanese()){
      alert("PC の Google Chrome を使用してください")
    }else{
      alert("You have to use PC's Google Chrome")
    }
    window.location = "https://www.google.com/chrome/browser/desktop/index.html";
    update_flag = false
    return 
  }

  if(  !detectmob() && update_flag && ( !( getChromeVersion() >= 66 ) ) ){
    if(checkJapanese()){
      alert("最新版のGoogle Chromeを使用してください")
      window.location = "https://support.google.com/chrome/answer/95414?co=GENIE.Platform%3DDesktop&hl=jp";
    }else{
      alert("You have to upgrade Laste PC's Google Chrome")
      window.location = "https://support.google.com/chrome/answer/95414?co=GENIE.Platform%3DDesktop&hl=en";
    }
    update_flag = false
    return 
  }

  // if ( (!iOS || !Android) && update_flag && ( detectmob() ) ){
  //   if(checkJapanese()){
  //     alert("PC の Google Chrome を使用してください")
  //     window.location = "https://workshop-live.com/";
  //   }else{
  //     alert("You have to upgrade the PC's Google Chrome")
  //     window.location = "https://workshop-live.com/?la=en";
  //   }
  //   update_flag = false
  //   return 
  // }

  return
}

export const getRoomId = (roomName) => {
  return window.fetch( "https://"+config.API_HOST+"/sessions/create/"+roomName, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(blob => blob.json())
}


export const getConfInfo = (token) => {
  return window.fetch("https://"+config.API_HOST+"/api/v1/get_conf_info?token="+token, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(blob => blob.json())
}


export const setRecord = (name,room,my_feed_id) => {
  return window.fetch("https://"+config.API_HOST+"/api/v1/set_record?user="+name+"&room_name="+room+"&my_feed_id="+my_feed_id, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(blob => blob.json())
}

export const setConfInfo = (name,room,user_type) => {
  return window.fetch("https://"+config.API_HOST+"/api/v1/set_conf_info?user="+name+"&conference_id_room="+room+"&user_type="+user_type, {
    method: 'GET',
    credentials: 'include',
    mode: ' no-cors',
    cache: 'default',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(blob => blob.json())
}


export const checkRoomState = (conference_id, user_id) => {
  return window.fetch("https://"+config.API_HOST+"/api/v1/room_state", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body:  "conference_id=" + conference_id + "&user_id=" + user_id
  }).then(blob => blob.json())
}

export const hangupConf = (room) => {
  return window.fetch("https://"+config.API_HOST+"/api/v1/hangup_conf?room_id="+room, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(blob => blob.json())
}

export const checkJapanese = () => {
  let locale = localStorage.getItem('locale')
  if (locale === 'ja') {
    return true
  } else if (locale === 'en') {
    return false
  } else {
    let default_lang =
      (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage
    if (default_lang === 'ja') {
      localStorage.setItem('locale', 'ja')
      return true
    } else {
      localStorage.setItem('locale', 'en')
      return false
    }
  }
};


export const flattenMessages = (nestedMessages, prefix = '') => {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key];
    let prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
};


export const displayRole = (pathname, role) => {
  if ((pathname.indexOf("jp") !== -1)) {
    if (role === "student") {
      return "受講者"
    }else if (role === "teacher"){
      return "プレゼンター"
    }else if (role === "facilitator"){
      return "アシスタント"
    }
  }else{
    if (role === "student") {
      return "受講者"
    }else if (role === "teacher"){
      return "プレゼンター"
    }else if (role === "facilitator"){
      return "アシスタント"
    }
  }
};


export const versionCompare = (v1, v2, options) => {
  var lexicographical = options && options.lexicographical
  var zeroExtend = options && options.zeroExtend
  var v1parts = v1.split('.')
  var v2parts = v2.split('.')

  function isValidPart (x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x)
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0')
    while (v2parts.length < v1parts.length) v2parts.push('0')
  }

  if (v1 === v2) {
    return false
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number)
    v2parts = v2parts.map(Number)
  }

  for (var i = 0; i < v1parts.length; ++i) {
    if (v2parts.length === i) {
      return false
    }

    if (v1parts[i] === v2parts[i]) {
      continue
    } else if (v1parts[i] > v2parts[i]) {
      return false
    } else {
      return true
    }
  }

  if (v1parts.length !== v2parts.length) {
    return true
  }

  return true
}


export const checkVersion = async () => {
  const versionsRef = database.ref('/versions');
  const response = (await versionsRef.once('value')).val()
  const latestVersion = response.web.version
  const currentVersion = version()
  let isUpdating = versionCompare(currentVersion, latestVersion)
  
  if(isUpdating){
    alert(`最新のバージョンは${latestVersion}です。現在のバージョンは${currentVersion}です。リロードするか、キャッシュをクリアしてください。`)
    window.location.reload()
    return true
  }else{
    return false
  }
}

export const getChromeVersion = () => {
  var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : false;
}

export const detectmob = () => {
 if( navigator.userAgent.match(/Android/i)
   || navigator.userAgent.match(/webOS/i)
   || navigator.userAgent.match(/iPhone/i)
   || navigator.userAgent.match(/iPad/i)
   || navigator.userAgent.match(/iPod/i)
   || navigator.userAgent.match(/BlackBerry/i)
   || navigator.userAgent.match(/Windows Phone/i)
 ){
    return true;
  }
 else {
    return false;
  }
}

export const ALertHeaderText = styled.div`
  font-size: 20px;
  line-height: 32px;
  color: rgba(50, 50, 93, 0.7);
`;

// Notice other param if you wanna change this!!
export const bitrate_const = isWebinar() ? [
  {bitrate: 0, label: "Select Bitrate"},
  {bitrate: 2000000, label: "2Mbps"},
  {bitrate: 1500000, label: "1.5Mbps"},
  {bitrate: 1000000, label: "1Mbps"},
  {bitrate: 500000, label: "500Kbps"},
  {bitrate: 320000, label: "320Kbps"},
  {bitrate: 150000, label: "150Kbps"},
  {bitrate: 32000, label: "32Kbps"} ] : 
  [
    {bitrate: 0, label: "映像品質を選択してください。"},
    {bitrate: 2000000, label: "高 (映像品質)"},
    {bitrate: 1000000, label: "標準 (映像品質)"},
    {bitrate: 100000, label: "低 (映像品質)"}
  ]


// Notice other param if you wanna change this!!

export const bitrate_const_index = {
  0: 0,
  2000000: 1,
  1500000: 2,
  1000000: 3,
  500000: 4,
  320000: 5,
  150000: 6,
  32000: 7}



export const checkPremiumRoom = (roomName) => {
  return window.fetch( "https://" + config.API_HOST + "/api/v1/room_check", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body:  "name=" + roomName
  }).then(blob => blob.json())
}

export const checkRoomExists = (roomName) => {
  const domainName = window.location.host.split(".")[0]
  return window.fetch( "https://" + config.API_HOST + "/api/v1/fv_room_check", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: "domain_name=" + domainName + "&name=" + roomName
  }).then(blob => blob.json())
}
export const checkDomainExpire = () => {
  const domainName = window.location.host.split(".")[0]
  return window.fetch("https://" + config.API_HOST + "/api/v1/get_fvdomain/"+domainName, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  }).then(blob =>  blob.json())
  
}
export const checkDevice =  (notification) =>  new Promise ((resolve) => {

  DetectRTC.load( async () => {
    
    const webCamPermission = await DetectRTC.isWebsiteHasWebcamPermissions
    if(!webCamPermission){
      await notification.addNotification({
        message: 'Webカメラの許可がされていません',
        level: 'error',
        position: 'tc',
        autoDismiss: 60
      });
    }
    
    const micPermission = await DetectRTC.isWebsiteHasMicrophonePermissions
    if(!micPermission){

      await notification.addNotification({
        message: 'マイクの許可がされていません',
        level: 'error',
        position: 'tc',
        autoDismiss: 60
      });
    }

    const webCamHas = await DetectRTC.hasWebcam
    if(!webCamHas){
      await notification.addNotification({
        message: 'Webカメラが検出できません',
        level: 'error',
        position: 'tc',
        autoDismiss: 60
      });
    }
    
    const micHas = await DetectRTC.hasMicrophone
    if(!micHas){
      await notification.addNotification({
        message: 'マイクが検出できません',
        level: 'error',
        position: 'tc',
        autoDismiss: 60
      });
    }
    
    if(!DetectRTC.hasSpeakers && !detectmob()){
      await notification.addNotification({
        message: 'スピーカーが検出できません',
        level: 'error',
        position: 'tc',
        autoDismiss: 60
      });
    }
    
    return resolve({webcam: webCamPermission * webCamHas, mic: micPermission * micHas })
  });

})


export const checkStorageDevice = async (audioDeviceId, videoDeviceId) => {

  const devices = await navigator.mediaDevices.enumerateDevices()
  let audio
  let video

  if( audioDeviceId === null || audioDeviceId === "default"){
    audio = null
  }else{
    devices.forEach((device) => {
      if(device.kind === 'audioinput') {        
        if(device.deviceId === audioDeviceId){
          audio = device.deviceId
        }
      }
    });
  }

  if( videoDeviceId === null || videoDeviceId === "default"){
    video = null
  }else{
    devices.forEach((device) => {
      if(device.kind === 'videoinput') {
        if(device.deviceId === videoDeviceId){
          video = device.deviceId
        }
      }
    });
  }
  return {audio, video}

}

export const gerAudioOutputDevice = async (audioOutputDeviceId) => {
  const devices = await navigator.mediaDevices.enumerateDevices()
  let audioOutput = null;
  if( audioOutputDeviceId === null || audioOutputDeviceId === "default"){
    audioOutput = null
  } else {
    devices.forEach((device) => {
      if(device.kind === 'audiooutput') {        
        if(device.deviceId === audioOutputDeviceId){
          audioOutput = device.deviceId
        }
      }
    });
  }

  return audioOutput;
}

export const displayPermission = {
  video: "Webカメラの許可してください",
  audio: "マイクの許可してください"
}


export const getUrlParams = (search) => {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
      let [key, val] = hash.split('=')
      return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}

export const getUrlVars = () => 
{
    var vars = [], max = 0, hash = "", array = "";
    var url = window.location.search;

        //?を取り除くため、1から始める。複数のクエリ文字列に対応するため、&で区切る
    hash  = url.slice(1).split('&');    
    max = hash.length;
    for (var i = 0; i < max; i++) {
        array = hash[i].split('=');    //keyと値に分割。
        vars.push(array[0]);    //末尾にクエリ文字列のkeyを挿入。
        vars[array[0]] = array[1];    //先ほど確保したkeyに、値を代入。
    }

    return vars;
}

export function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};
export const isSpacee = () => {
  // Debug
  if(window.location.hostname === "localhost" ){
    return false
  }
  
  if(window.location.hostname === "spacee-video-dev-c25d0.firebaseapp.com" || window.location.hostname === "spac.ee"){
    return true
  }else{
    return false
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null ||
      typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

export function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

export function isWindows() {
  // return navigator.platform.indexOf('Win') > -1
}
export const isSentry = (error) => {
  console.error(error)
  Sentry.captureException(error)
}


export const webrtcLog = function(){
  if(!config.WEBRTC_LOG) return
  console.log.apply(console, arguments);
};
export const APIFunc = async (url) => {
  const resp = await fetch('https://cors-anywhere.herokuapp.com/'+url,{
   method: 'GET',
   header:{
     origin: window.location.origin,
     'Content-Type': 'application/json',
   }
 })
 const data = await resp.text();
 return data;
 }
export const toggleFullscreen = function(vid){
  try{
    var elem = document.getElementById(vid);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { 
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }else if (isSafari){
      elem.webkitEnterFullscreen()
    }
    return true
  }catch(error){
    const message = "video closeFullscreen() failed"
    isSentryBreadcrumbs(error,message)
  }  
}
export const closeFullscreen = function(){
  try{
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    return true
  }
  catch(error){
    const message = "video closeFullscreen() failed"
    isSentryBreadcrumbs(error,message)
  }
}
export const exitHandler = () => {
  if (document.webkitIsFullScreen === false || document.mozFullScreen === false || document.msFullscreenElement === false)
  {
    return true
  }
}

export const isSentryBreadcrumbs = (error,message) => {
  console.log(error)
     Sentry.addBreadcrumb({
      category: 'error',
       message: message,
       level: Sentry.Severity.info
     });
     Sentry.captureException(error);
}



// WEBPACK FOOTER //
// ./src/lib/lib.js